import { supportedCurrencies } from "../../app/constants/currencies";
import { i18n, mapLangCodeToLocale } from "../../i18n/i18n";

export const mapCurrencyToSymbols = (currency: string) => {
    if (supportedCurrencies.eur === currency) return "\u20AC"; // €
    if (supportedCurrencies.usd === currency) return "\u0024"; // $
    if (supportedCurrencies.uah === currency) return "\u20B4"; // ₴
    if (supportedCurrencies.pln === currency) return "z\u0142"; // zł
};

export const getFormattedCurrencyByLang = (value: number, showCurrency = true) => {
    const locale = mapLangCodeToLocale(i18n.language);
    const formattedNimber = new Intl.NumberFormat(
        locale,
        showCurrency
            ? {
                  style: "currency",
                  currency: getCurrencyCodeByLocale(locale),
              }
            : {
                  style: "decimal",
              }
    ).format(value);
    return value < 1 ? "" : formattedNimber;
};

export const getCurrencySymbol = (locale: string) => {
    const formatted = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: getCurrencyCodeByLocale(locale),
    }).format(0);
    return formatted.replace(/[\d\s,]/g, "");
};

export const getCurrencyCodeByLocale = (locale: string) => {
    switch (locale) {
        case "uk-UA":
            return "UAH"; // Ukrainian Hryvnia
        case "en-US":
            return "USD"; // United States Dollar
        case "pl-PL":
            return "PLN"; // Polish Zloty
        default:
            return "UAH";
    }
};
